import {
  Box,
  CustomModalLayout,
  Divider,
  Heading,
  Text,
  TextButton,
} from '@wix/design-system';
import { DataHooks } from '../../../../constants/dataHooks';
import { PreSteps, PrerequisiteStep, prerequisiteSteps } from './PreSteps';
import css from '../../TemplatePage.scss';
import { TerminalExample } from './TerminalExample/TerminalExample';
import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useTemplatesData } from '../../../../hooks/useTemplatesData';
import { useTemplatesPageBi } from '../../../../hooks/useTemplatesPageBi';
import { useExperiments } from '@wix/fe-essentials/react';
import { getIsAppTemplatesRedisgn } from '../../../../utils/experiments';

export const CLIModalLayout = ({ closeModal }) => {
  const { t } = useTranslation();
  const { currentTemplate: template } = useTemplatesData();
  const { reportCloseCliModalClick, reportCliPrerequisiteLinkClick } =
    useTemplatesPageBi();
  const learnMoreLink = prerequisiteSteps[PrerequisiteStep.CliLearnMore];
  const { experiments } = useExperiments({ readOnly: true });
  const isStartFromScratchRedesignEnabled =
    getIsAppTemplatesRedisgn(experiments);
  const onLinkClick = () => {
    reportCliPrerequisiteLinkClick(
      template.id,
      PrerequisiteStep.CliLearnMore,
      learnMoreLink,
    );
  };

  const onCloseClick = () => {
    reportCloseCliModalClick(template.id);
    closeModal();
  };

  return (
    <CustomModalLayout
      dataHook={DataHooks.CLIModalLayout}
      width={600}
      showHeaderDivider
      showFooterDivider
      title={t('app.template-page.modal.cli.title')}
      primaryButtonText={t('app.template-page.modal.primary-button')}
      onCloseButtonClick={onCloseClick}
      primaryButtonOnClick={onCloseClick}
    >
      <Heading size="small">
        {t('app.template-page.modal.cli.steps-title')}
      </Heading>
      <Text size="small" weight="thin">
        {t('app.template-page.modal.cli.steps-subtitle')}
      </Text>
      <PreSteps />
      <div className={css.modalDivider}>
        <Divider />
      </div>
      <Heading size="small">
        {t('app.template-page.modal.cli.select-and-copy-title')}
      </Heading>

      {isStartFromScratchRedesignEnabled ? (
        <Box verticalAlign="middle" gap="2px">
          <Text size="small" weight="thin">
            {t('app.template-page.modal.cli.select-and-copy-subtitle')}
          </Text>
          <TextButton
            as="a"
            size="small"
            weight="thin"
            target="_blank"
            onClick={onLinkClick}
            href={learnMoreLink}
            dataHook={DataHooks.CLIModalLearnMoreLink}
          >
            {t('app.template-page.modal.cli.select-and-copy-learn-more')}
          </TextButton>
        </Box>
      ) : (
        <Text size="small" weight="thin">
          {t('app.template-page.modal.cli.select-and-copy-subtitle')}
        </Text>
      )}
      <TerminalExample />
    </CustomModalLayout>
  );
};
